import './styles/VariablesDescription.scss';

import { Check, Close } from '@mui/icons-material';
import { Card, Chip, Grid } from '@mui/material';

import clsx from 'clsx';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { TemplateVariables } from 'types/AppTypes';

interface Props {
  variables: TemplateVariables;
  i18nDictionary: Record<string, () => string>;
  ignoreTextScope?: boolean;
}

export default function VariablesDescription({
  variables,
  i18nDictionary,
  ignoreTextScope
}: Props): ReactElement {
  const { t } = useTranslation();
  return (
    <Grid container className="template-variables-description" spacing={2}>
      {Object.keys(variables).map(v => {
        const scope = variables[v].scope;
        const key = v.slice(3, -3);
        return (
          <Grid item xs={12} md={6} key={v}>
            <Card className="template-variables-description__variable">
              <Grid container className="template-variables-description__variable__key">
                {v}
              </Grid>
              <Grid container className="template-variables-description__variable__description">
                {i18nDictionary[key] ? t(i18nDictionary[key]()) : variables[v].description}
              </Grid>
              <Grid
                container
                className="template-variables-description__variable__scope"
                spacing={2}
              >
                {Object.keys(scope).map(s => {
                  if (!ignoreTextScope || s !== 'text') {
                    const active = scope[s];
                    return (
                      <Grid item key={s}>
                        <Chip
                          size="small"
                          label={t(translations.common[s]())}
                          className={clsx('template-variables-description__variable__scope__item')}
                          icon={
                            active ? (
                              <Check style={{ color: 'lightgreen' }} />
                            ) : (
                              <Close style={{ color: 'darkred' }} />
                            )
                          }
                          variant="outlined"
                        />
                      </Grid>
                    );
                  }

                  return null;
                })}
              </Grid>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
}
